export function convertDataToDict(data) {
  const resultDict = {}

  function traverse(node, parentKey = '') {
    const currentKey = `${parentKey}${node.text}`
    resultDict[currentKey] = (node.child || [])
      .map((child) => child.Id)
      .join(',')
  }

  for (const item of data) {
    traverse(item)
  }

  return resultDict
}

export function isNumber(str) {
  return !isNaN(Number(str))
}

export function extractNumbers(inputString) {
  const elements = inputString.split(',').map((el) => el.trim())

  const numbersArray = elements
    .filter((el) => !isNaN(el))
    .map((el) => parseInt(el, 10))

  return numbersArray.join(',')
}
export function extractNonNumbers(inputString) {
  const elements = inputString.split(',').map((el) => el.trim())

  const nonNumbersArray = elements.filter((el) => isNaN(el))

  return nonNumbersArray.join(',')
}

export function replaceStringsWithNumbers(inputString, replacementDict) {
  for (const key in replacementDict) {
    const regex = new RegExp(`\\b${replacementDict[key]}\\b`, 'g')
    inputString = inputString.replace(regex, key)
  }
  return inputString
    .split(',')
    .filter((item) => !isNaN(item))
    .join(',')
}
